import HeaderText from '../../atomsLegacy/typography/HeaderText';
import {
  Description,
  Label,
  LabelToggle as StyledLabelToggle,
  ToggleContainer,
} from './LabelToggle.styles';
import * as React from 'react';
import { Switch } from 'src/components/atoms';
import { SubheaderText } from 'src/components/atomsLegacy/typography/SubheaderText/SubheaderText.styles';

export interface LabelToggleProps {
  label: string;
  description?: string;
  handleToggle: (newToggleValue: boolean) => void;
  checked: boolean;
  id?: string;
  disabled?: boolean;
  testId?: string;
  size?: 'md' | 'sm';
}

export const LabelToggle: React.FC<LabelToggleProps> = (
  props: LabelToggleProps,
) => {
  let labelTitle;
  if (props.size === 'sm') {
    labelTitle = <SubheaderText>{props.label}</SubheaderText>;
  } else {
    labelTitle = <HeaderText weight="regular" label={props.label} />;
  }

  return (
    <StyledLabelToggle>
      <ToggleContainer size={props.size}>
        <Switch
          onClick={props.handleToggle}
          checked={props.checked}
          disabled={props.disabled}
          data-testid={props.testId}
        />
      </ToggleContainer>
      <Label>
        {labelTitle}
        {props.description && <Description>{props.description}</Description>}
      </Label>
    </StyledLabelToggle>
  );
};

export default LabelToggle;
